import React from "react";
import { Link } from "react-router-dom";
import Layout from "@/components/Layout";
import { Compass, Home } from "lucide-react";

export default function NotFound() {
  return (
    <Layout>
      <div className="max-w-3xl mx-auto px-4 sm:px-6 py-24 text-center" data-testid="not-found-page">
        <span className="tile w-16 h-16 mx-auto"><Compass className="w-7 h-7 relative z-10" /></span>
        <div className="font-display text-6xl md:text-7xl mt-6">Lost the plot.</div>
        <p className="text-muted mt-3">This page doesn't exist — but you're still signed in. Pick a direction:</p>
        <div className="mt-7 flex flex-wrap gap-3 justify-center">
          <Link to="/" className="btn-lime" data-testid="notfound-home"><Home className="w-4 h-4" /> Back home</Link>
          <Link to="/ai-gallery" className="btn-ghost" data-testid="notfound-gallery">AI Photo Gallery</Link>
          <Link to="/organisers" className="btn-ghost" data-testid="notfound-organisers">For Organisers</Link>
        </div>
      </div>
    </Layout>
  );
}
